let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4Zl8Z")).then(() => parcelRequire('cOQz3'));